module.exports = __webpack_public_path__ + "static/media/1.890a9d64.svg";